import md5 from 'md5';
import {
  FETCH_SKU_LIST_SEARCH,
  FETCH_SKU_LIST_SEARCH_FULFILLED,
  FETCH_SKU_LIST_SEARCH_REJECTED,
} from 'b2b-apps/shop/catalog/redux/skuList/actionTypes';
import {
  FetchSkuListSearchAction,
  FetchSkuListSearchFulfilledAction,
  FetchSkuListSearchRejectedAction,
  SkuListSearchType,
} from 'b2b-apps/shop/catalog/redux/skuList/types';

const fetchSkuListSearch = (query: string): FetchSkuListSearchAction => {
  const queryId = md5(query.toLowerCase());
  return {
    type: FETCH_SKU_LIST_SEARCH,
    payload: {
      query,
      queryId,
    },
  };
};

const fetchSkuListSearchFulfilled = (
  response: SkuListSearchType,
  queryId: string,
): FetchSkuListSearchFulfilledAction => ({
  type: FETCH_SKU_LIST_SEARCH_FULFILLED,
  payload: {
    data: response,
    queryId,
  },
});

const fetchSkuListSearchRejected = (
  error: ErrorType,
  queryId: string,
): FetchSkuListSearchRejectedAction => ({
  type: FETCH_SKU_LIST_SEARCH_REJECTED,
  payload: {
    error,
    queryId,
  },
});

export {
  fetchSkuListSearch,
  fetchSkuListSearchFulfilled,
  fetchSkuListSearchRejected,
};
